import { render, staticRenderFns } from "./salesReturnPurchaseRecord.vue?vue&type=template&id=5328e86c"
import script from "./salesReturnPurchaseRecord.vue?vue&type=script&lang=js"
export * from "./salesReturnPurchaseRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports